import React, { useEffect, useState, useCallback, useMemo } from "react";
import * as S from "./styles";
import { ChipRow, Chip, revealChip } from "../../utils/globalStyles/chips";
import { getNews } from "../../utils/services/modules/news";
import { useUserContext } from "../../contexts/user/userContext";
import {
  CATEGORIES,
  CategoryFilter,
  IAnnouncement,
} from "../../utils/announcements";
import NewsList from "../newsList";
import NewsModal from "../modalNews";

const News: React.FC = () => {
  const { state } = useUserContext();
  const { user } = state;

  const [news, setNews] = useState<IAnnouncement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [category, setCategory] = useState<CategoryFilter>("todos");
  const [selected, setSelected] = useState<IAnnouncement | null>(null);

  // ✅ Correção aqui: useCallback para evitar warning e garantir estabilidade
  const fetchNews = useCallback(async () => {
    if (!user?.token) return;

    setLoading(true);
    setError(false);
    try {
      const response = await getNews(user.token);
      setNews(response);
    } catch (err) {
      console.error("Erro ao buscar anúncios:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [user?.token]);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]); // só depende do token (antes buscava de novo a cada mudança no user)

  // Quantidade por categoria; só mostra chips de categorias com anúncio
  const counts = useMemo(() => {
    const result: Partial<Record<CategoryFilter, number>> = {
      todos: news.length,
    };
    news.forEach((announcement) => {
      const key = announcement.category ?? "outros";
      result[key] = (result[key] ?? 0) + 1;
    });
    return result;
  }, [news]);

  const visibleCategories = CATEGORIES.filter(
    (option) => option.value === "todos" || counts[option.value],
  );

  const filtered =
    category === "todos"
      ? news
      : news.filter(
          (announcement) => (announcement.category ?? "outros") === category,
        );

  return (
    <S.Container>
      <S.Label>Anúncios</S.Label>

      {visibleCategories.length > 2 && (
        <S.FilterBar>
          <ChipRow>
            {visibleCategories.map(({ value, label, Icon }) => (
              <Chip
                key={value}
                type="button"
                $active={category === value}
                onClick={(e) => {
                  revealChip(e.currentTarget);
                  setCategory(value);
                }}
              >
                <Icon style={{ fontSize: 16 }} />
                {label}
                <S.Count $active={category === value}>{counts[value]}</S.Count>
              </Chip>
            ))}
          </ChipRow>
        </S.FilterBar>
      )}

      <NewsList
        // trocar a key refaz a animação de entrada ao mudar de categoria
        key={category}
        news={filtered}
        loading={loading}
        error={error}
        onRetry={fetchNews}
        emptyMessage={
          category === "todos"
            ? "Nenhum anúncio encontrado!"
            : `Nenhum anúncio em ${
                CATEGORIES.find((option) => option.value === category)?.label
              } ainda.`
        }
        onSelect={setSelected}
      />

      <NewsModal announcement={selected} onClose={() => setSelected(null)} />
    </S.Container>
  );
};

export default News;
